<template>
  <div class="container">
    <h2 class="sectionTitle" data-aos="fade-up" data-aos-offset="120">
      Чому саме BEST<br />
      Company Insight?
    </h2>
    <div class="iconsWrapper">
      <div class="iconItem" data-aos="fade-up" data-aos-offset="120">
        <img
          class="iconImg img1"
          src="@/assets/icons_new/voiceOverIcon.svg"
          alt="voiceOverIcon"
        />
        <span class="text18"
          >Підвищення впізнаваності бренду серед амбітної молоді. Окрім самої
          зустрічі в офісі, ми розповідаємо про вашу компанію у наших соцмережах
          та на тижні інформаційних стійок у Львівській політехніці.</span
        >
      </div>
      <div class="iconItem" data-aos="fade-up" data-aos-offset="120">
        <img
          class="iconImg img2"
          src="@/assets/icons_new/trendingIcon.svg"
          alt="trendingIcon"
        />
        <span class="text18"
          >Швидкість та ефективність. Всього за кілька годин ви можете
          розповісти та показати групі зацікавлених студентів вашу компанію, її
          внутрішні процеси та атмосферу колективу.</span
        >
      </div>
      <div class="iconItem" data-aos="fade-up" data-aos-offset="120">
        <img
          class="iconImg img3"
          src="@/assets/icons_new/peopleIcon.svg"
          alt="poepleIcon"
        />
        <span class="text18"
          >Допомога майбутнім робочим кадрам. Учасники отримують розуміння
          роботи компанії зсередини, знання про можливі напрями розвитку себе і
          цікавий досвід.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Oppotunities'
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.iconsWrapper {
  margin-top: 4.58rem;
  display: flex;
  align-items: flex-start;
  flex: 1 1 0px;
  gap: 9.375rem;
  justify-content: space-between;
}

.iconItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.875rem;
}

.iconItem:last-child {
  margin-right: 0;
}

.iconImg {
  height: auto;
  width: 6.1rem;
  display: block;
}

@media screen and (max-width: 768px) {
  .iconsWrapper {
    margin-top: 11.5625rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .iconItem {
    gap: 5.625rem;
    text-align: center;
    width: 62.5rem;
  }

  .img2 {
    margin-bottom: -2rem;
  }

  .iconImg {
    width: 18.125rem;
    height: auto;
  }
}
</style>
